import { gql } from '@apollo/client';

/**
 * The call log (card 21.6, on card 16's `crmCalls`): ilbp-backend
 * docs/CARD_21_6_CALL_LOG.md and CRM_CONTACT_QUERY_FRONTEND.md §27. Fields are
 * written out in each document, not shared as fragments: the tests run without
 * __typename (CLAUDE.md).
 */

/**
 * One page of calls. `withCounts` asks for the total and the counts by outcome
 * and caller: once per filter, since paging does not change them. A page is
 * reached by `after` (next) where its cursor is known, by `skip` otherwise.
 */
export const CRM_CALL_LOG = gql`
  query CrmCallLog($filter: CrmCallFilter, $take: Int, $after: String, $skip: Int, $withCounts: Boolean!) {
    crmCalls(filter: $filter, take: $take, after: $after, skip: $skip) {
      hasNextPage
      endCursor
      total @include(if: $withCounts)
      byOutcome @include(if: $withCounts) {
        outcome
        count
      }
      byCaller @include(if: $withCounts) {
        adminId
        authorContactId
        isYou
        count
        admin {
          id
          firstName
          lastName
        }
        author {
          id
          fullName
        }
      }
      items {
        id
        contactId
        adminId
        authorContactId
        source
        direction
        method
        outcome
        notes
        durationSec
        supportLevel
        occurredAt
        followUpAt
        followUpDoneAt
        followUpOpen
        followUpDue
        setDoNotCall
        recordingUrl
        editable
        createdAt
        updatedAt
        contact {
          id
          fullName
          primaryEmail
          primaryPhone
          doNotCall
          doNotContact
          mergedIntoId
        }
        admin {
          id
          firstName
          lastName
        }
        author {
          id
          fullName
        }
        followUpDoneBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

/** The name on the "Calls to …" chip when the log shows one person's calls. */
export const CRM_CALL_LOG_PERSON = gql`
  query CrmCallLogPerson($id: Int!) {
    crmContact(id: $id) {
      id
      fullName
      primaryEmail
    }
  }
`;

/**
 * Corrects a call the admin logged in this panel: only the fields sent change.
 * Refused for the history's calls and other admins' (CRM_CALL_NOT_EDITABLE).
 */
export const CRM_UPDATE_CALL = gql`
  mutation CrmUpdateCall($id: Int!, $input: CrmUpdateCallInput!) {
    crmUpdateCall(id: $id, input: $input) {
      id
      outcome
      method
      direction
      notes
      durationSec
      supportLevel
      followUpAt
      followUpDoneAt
      followUpOpen
      followUpDue
      recordingUrl
      updatedAt
    }
  }
`;
